// src/pages/faq/VerPregunta.js
import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Badge from 'react-bootstrap/Badge'
import { Offcanvas, Card } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import RichTextPreview from 'components/RichText/RichTextPreview'

import './faq.css'

function VerPregunta(props) {
	const { pregunta, mostrar, cancelar } = props

	const handleClose = () => {
		cancelar()
	}

	const renderRespuesta = () => {
		if (!pregunta.respuesta) {
			return <p className="text-muted">No hay respuesta disponible</p>
		}

		try {
			// Intentar parsear el contenido como JSON para RichTextPreview
			const contenidoJSON = JSON.parse(pregunta.respuesta)
			return <RichTextPreview rawContent={contenidoJSON} />
		} catch (e) {
			// Si no es JSON, mostrarlo como texto plano
			return <div className="respuesta-text">{pregunta.respuesta}</div>
		}
	}

	if (!pregunta || !mostrar) {
		return null
	}

	// render
	return (
		<Offcanvas show={mostrar} onHide={handleClose} placement="end" className="pregunta-detalle-panel" style={{ width: '60%' }}>
			<PanelHeader
				onClick={handleClose}
				iconClass="fa-arrow-left"
				btnText="Atrás"
				text="Pregunta Frecuente"
			/>
			<Offcanvas.Body id="ver-pregunta">
				<Card className="pregunta-card mb-4 border-0 shadow-sm">
					<Card.Body>
						<div className="mb-4">
							<div className="d-flex justify-content-between align-items-start mb-3">
								<Badge bg={pregunta.activo ? 'success' : 'secondary'} className="px-3 py-2">
									<i className={`fa ${pregunta.activo ? 'fa-check-circle' : 'fa-times-circle'} me-1`}></i>
									{pregunta.activo ? 'Activa' : 'Inactiva'}
								</Badge>
								<Badge bg="info" className="px-3 py-2">
									<i className="fa fa-sort-amount-down me-1"></i>
									Orden: {pregunta.orden}
								</Badge>
							</div>

							<h2 className="pregunta-titulo mb-4">
								<i className="fa fa-question-circle text-primary me-2"></i>
								{pregunta.pregunta}
							</h2>

							<div className="respuesta-container">
								<h5 className="mb-3 text-muted">
									<i className="fa fa-comment-dots me-2"></i>
									Respuesta:
								</h5>
								{renderRespuesta()}
							</div>
						</div>
					</Card.Body>

					<Card.Footer className="bg-white border-0 pt-0">
						<Row className="mt-4">
							<Col>
								<div className="detalles-adicionales">
									<small className="text-muted">
										<strong>ID:</strong> {pregunta.id}
										{pregunta.fechaCreacion && (
											<>
												{' | '}
												<strong>Creada:</strong> {new Date(pregunta.fechaCreacion).toLocaleDateString('es-ES', {
													day: '2-digit',
													month: '2-digit',
													year: 'numeric',
													hour: '2-digit',
													minute: '2-digit'
												})}
											</>
										)}
										{pregunta.fechaModificacion && (
											<>
												{' | '}
												<strong>Modificada:</strong> {new Date(pregunta.fechaModificacion).toLocaleDateString('es-ES', {
													day: '2-digit',
													month: '2-digit',
													year: 'numeric',
													hour: '2-digit',
													minute: '2-digit'
												})}
											</>
										)}
									</small>
								</div>
							</Col>
						</Row>
					</Card.Footer>
				</Card>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="primary" onClick={handleClose} className="w-100">
					Cerrar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default VerPregunta